import type { ComponentProps } from "@blocknote/react";
import classNames from "classnames";
import { SmallTextMain } from "ui";

type Props = ComponentProps["SuggestionMenu"]["Label"];

export function Label({ children, className }: Props) {
  return <SmallTextMain className={classNames(className)}>{children}</SmallTextMain>;
}
